import React from "react";

export function DashbboardHelp11() {
    return (
        <div style={{
            fontFamily: 'PPMoriRegular',
            textAlign: 'justify',
            marginRight: 40,
            fontSize: '1.2em'
        }}>
            <p>In the Slow-Growth Lifestyle scenario, the focus is on curbing urban expansion while
                significantly increasing reforestation efforts and fostering sustainable lifestyle choices. This
                approach is aligned with government initiatives aiming to find a harmony between development and
                environmental conservation. The strategy underscores growth models that limit urban sprawl, enhance
                green spaces, and prioritize CO2 sequestration through concerted reforestation efforts.
                <ul>
                    <li><b>Urban Development:</b> The implementation of strict regulations is pivotal to controlling
                        urban sprawl and preventing deforestation. Efforts are concentrated on enhancing the
                        sustainability of existing urban areas by minimizing the environmental footprint of buildings
                        through eco-friendly design and construction practices.
                    </li>
                    <li><b>Transportation:</b> A paradigm shift towards non-motorized transportation is advocated, with
                        a preference for walking and cycling over car usage. This transition aims to decrease carbon
                        emissions and foster healthier living environments. By promoting non-motorized modes of
                        transport, the strategy contributes to reducing the reliance on fossil fuels and enhancing the
                        quality of urban life.
                    </li>
                    <li><b>Vegetation:</b> Reforestation is aggressively pursued, particularly focusing on reclaiming
                        areas previously utilized for palm oil plantations and other low-value land uses. This
                        initiative is designed to increase the region's carbon sequestration capacity, playing a critical
                        role in the global effort to mitigate climate change. By increasing forested areas, the strategy
                        not only contributes to carbon capture but also enhances biodiversity and strengthens the
                        ecological integrity of the region.
                    </li>
                </ul></p>
            <p></p>
        </div>
    )
}